var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.682 19.682a4.5 4.5 0 1 0-6.364-6.364m6.364 6.364a4.5 4.5 0 1 1-6.364-6.364m6.364 6.364l-6.364-6.364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15H2V3h20v7M5.667 9h3M10.5 9h3m1.833 0h3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockList);
export default __webpack_public_path__ + "static/media/block-list.dcb309dd78e0b3bad1f9d10b53c3969c.svg";
export { ForwardRef as ReactComponent };